export enum MessageStatusEnum {
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}